import styled, { keyframes } from 'styled-components';

const scan = keyframes`
    0% { top: 8%; }
    50% { top: 90%; }
    100% { top: 8%; }
`;

export const Viewport = styled.div`
    position: relative;
    background: #000;
    border-radius: 12px;
    overflow: hidden;
    aspect-ratio: 3 / 2;
`;

export const Corner = styled.span<{ $pos: 'tl' | 'tr' | 'bl' | 'br' }>`
    position: absolute;
    width: 28px;
    height: 28px;
    border: 3px solid #4b7cf3;
    pointer-events: none;
    ${({ $pos }) => ($pos[0] === 't' ? 'top: 12%;' : 'bottom: 12%;')}
    ${({ $pos }) => ($pos[1] === 'l' ? 'left: 10%;' : 'right: 10%;')}
    ${({ $pos }) =>
        $pos[0] === 't' ? 'border-bottom: none;' : 'border-top: none;'}
    ${({ $pos }) =>
        $pos[1] === 'l' ? 'border-right: none;' : 'border-left: none;'}
`;

export const ScanLine = styled.span`
    position: absolute;
    left: 10%;
    right: 10%;
    height: 2px;
    background: #4b7cf3;
    box-shadow: 0 0 8px #4b7cf3;
    pointer-events: none;
    animation: ${scan} 2.4s ease-in-out infinite;
`;

export const Hint = styled.div`
    margin-top: 12px;
    text-align: center;
    font-size: 13px;
    color: ${({ theme }) => theme.colors.lightFont};
`;

export const ErrorMessage = styled.div`
    padding: 24px 12px;
    text-align: center;
    font-size: 13px;
    color: #d21e28;
`;
